import ky from 'ky';
import Cookies from 'js-cookie';
import jwtDecode from 'jwt-decode';
import _ from 'lodash';
import { IResponse, Image } from './types';
import { COOKIENAME, API, UPLOAD } from './config';
import md5 from 'md5';

const cdn = ky.extend({
  prefixUrl: UPLOAD,
  hooks: {
    beforeError: [error => error.response.json()],
    beforeRequest: [
      request => {
        const timestamp = new Date().getTime();
        const token = Cookies.get(COOKIENAME);
        const payload = jwtDecode<any>(_.toString(token));
        const hash = md5(`${payload.cdn_token}${timestamp}`);
        request.headers.set('Authorization', `Basic ${timestamp}.${hash}`);
      },
    ],
  },
  retry: 1,
});

export const uploadImages = async (
  insider_id: number,
  files: Image[],
): Promise<Image[] | undefined> => {
  try {
    const images: Image[] = [];
    if (files.length > 0) {
      const formData = new FormData();
      _.forEach(files, v => {
        if (!_.isUndefined(v.blob)) {
          formData.append('attachment', v.blob);
        } else {
          images.push(v);
        }
      });
      if (images.length < files.length) {
        const result = await cdn
          .post(`api/upload/images/${insider_id}`, {
            body: formData,
          })
          .json<
            IResponse<{ id: string; name: string; insider_id: number }[]>
          >();
        _.forEach(result.data, v => {
          images.push({ imageId: v.id, src: v.name });
        });
      }
    }
    return images;
  } catch (e) {
    throw e;
  }
};

const api = ky.extend({
  prefixUrl: API,
  hooks: {
    beforeError: [error => error.response.json()],
    beforeRequest: [
      request => {
        request.headers.set(
          'Authorization',
          `Bearer ${Cookies.get(COOKIENAME)}`,
        );
      },
    ],
  },
  timeout: 60000,
  retry: 1,
});

export default api;
